import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18n from 'i18n';
import styles from './LanguageSelection.module.css';
import UK from './flags/uk.svg';
import FR from './flags/fr.svg';
export default function LanguageSelection() {
    var changeLanguage = function (language) {
        i18n.changeLanguage(language);
    };
    return (_jsxs("div", { children: [_jsx("button", { onClick: function () { return changeLanguage('en'); }, className: styles.button, children: _jsx("img", { src: UK, alt: "English", className: styles.flag }) }), _jsx("button", { onClick: function () { return changeLanguage('fr'); }, className: styles.button, children: _jsx("img", { src: FR, alt: "Fran\u00E7ais", className: styles.flag }) })] }));
}
